import script from "./OpenDataUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenDataUpload.vue?vue&type=script&setup=true&lang=js"

import "./OpenDataUpload.vue?vue&type=style&index=0&id=648c2904&lang=css"

const __exports__ = script;

export default __exports__